import { axios } from '../utilities/axios';

class DiscountsApi {
  static fetchDiscounts(stateAbbreviation) {
    const endpoint = `${process.env.CVNA_APP_KONG_URL}/core/discount/api`;
    return axios.get(`${endpoint}/v1/discount?stateabbreviation=${stateAbbreviation}`).then(res => res.data);
  }
}

export default DiscountsApi;
